/* global axios */
import ApiClient from './ApiClient';

class FollowUpsAPI extends ApiClient {
  constructor() {
    super('follow_ups', { accountScoped: true });
    this.conversationId = null;
  }

  get url() {
    return `${this.baseUrl()}/conversations/${this.conversationId}/follow_ups`;
  }

  get(conversationId) {
    this.conversationId = conversationId;
    return axios.get(this.url);
  }

  create(conversationId, { description, scheduledAt }) {
    this.conversationId = conversationId;
    return super.create({ description, scheduled_at: scheduledAt });
  }

  complete(conversationId, id) {
    this.conversationId = conversationId;
    return axios.post(`${this.url}/${id}/complete`);
  }

  cancel(conversationId, id) {
    this.conversationId = conversationId;
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new FollowUpsAPI();
